import React from 'react';
import { TrendingUp, ArrowUp } from 'lucide-react';
import { formatCurrency } from '../utils/currencyUtils';
import type { ExchangeRates } from '../utils/currencyUtils';

interface TrendingSectionProps {
  type: 'coins' | 'dex';
  currency: string;
  exchangeRates: ExchangeRates;
}

export function TrendingSection({ type, currency, exchangeRates }: TrendingSectionProps) {
  const trendingCoins = [
    { symbol: 'SOL', price: 142.85, change: 4.61, logo: 'https://assets.coingecko.com/coins/images/4128/small/solana.png' },
    { symbol: 'AVAX', price: 38.92, change: 11.15, logo: 'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png' },
    { symbol: 'ATOM', price: 15.23, change: 8.32, logo: 'https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png' },
    { symbol: 'DOT', price: 9.45, change: 5.73, logo: 'https://assets.coingecko.com/coins/images/12171/small/polkadot.png' },
    { symbol: 'NEAR', price: 3.82, change: 7.24, logo: 'https://assets.coingecko.com/coins/images/10365/small/near.jpg' }
  ];

  const trendingDex = [
    { pair: 'ETH/BTC', price: 0.05512, change: 2.34, logo: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png' },
    { pair: 'SOL/BTC', price: 0.00198, change: 4.61, logo: 'https://assets.coingecko.com/coins/images/4128/small/solana.png' },
    { pair: 'BNB/BTC', price: 0.00432, change: 1.82, logo: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png' },
    { pair: 'XRP/BTC', price: 0.00001625, change: 1.43, logo: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png' },
    { pair: 'ADA/BTC', price: 0.00000912, change: 2.16, logo: 'https://assets.coingecko.com/coins/images/975/small/cardano.png' }
  ];

  const data = type === 'coins' ? trendingCoins : trendingDex;
  
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-blue-500" />
          {type === 'coins' ? 'Trending Coins' : 'Trending on DexScan'}
        </h2>
      </div>

      <div className="space-y-4">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-500 w-4">{index + 1}</span>
              <img src={item.logo} alt={type === 'coins' ? item.symbol : item.pair} className="w-6 h-6 rounded-full" />
              <span className="font-medium text-gray-900">
                {type === 'coins' ? item.symbol : item.pair}
              </span>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-medium text-gray-900">
                {formatCurrency(item.price, currency, exchangeRates)}
              </span>
              <div className="flex items-center text-green-600">
                <ArrowUp className="w-4 h-4" />
                <span className="text-sm">{item.change.toFixed(2)}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}